import React, { Component, ContextType } from 'react';
import { SearchContext } from '../../context/SearchContext';
import log from 'loglevel';
import FacetFieldPieCharts from "./facets/FacetFieldPiecharts";
import './AnalyticsResult.scss';
import { DefaultFieldNames, Field } from '../../types/Field';
import { FacetValue, FacetValues, FacetValuesCount } from '../../types/Facet';
import { facets } from '../search/facets/facetLogic';

interface AnalyticsResultState {
    isPanelOpen: boolean;
    facetExpanded: string;
}

class AnalyticsResult extends Component<{}, AnalyticsResultState> {
    static contextType = SearchContext;
    context!: ContextType<typeof SearchContext>;

    state: AnalyticsResultState = {
        isPanelOpen: false,
        facetExpanded: ''
    };

    getFacetFilterData = (selectedFacets: FacetValues<FacetValue>[]) => {
        let filterDataArr: { key: string; values: string[]; name: string }[] = [];
        
        selectedFacets.forEach((selectedFacet) => {
            let filterDataJson = {
                key: '',
                values: [] as string[],
                name: '',
            };
            if (selectedFacet.facetName !== 'TimeStart' && selectedFacet.facetName !== 'Duration') {
                const field = this.context.filterableUIFields?.find((f: Field) => f.name === selectedFacet.facetName);
                if (!field) return;
                filterDataJson.key = field.systemSettings.displayName;
                filterDataJson.values = selectedFacet.facetValues.map((fv: FacetValue) => fv.getStringValue());
                filterDataJson.name = field.name;
                filterDataArr.push(filterDataJson);
            }
        });
        return filterDataArr;
    };

    facetChanged = (facetName: string, facetValue: FacetValue) => {
        const field = this.context.filterableUIFields?.find((f: Field) => f.name === facetName);
        if (!field) {
            throw new Error(`Field not found for facet name: ${facetName}`);
        }
        
        const facetLogic = facets.getFacetLogicByType(field.systemSettings.type);
        this.context.updateFacetSelection(facetName, facetValue, facetLogic.createUpdatedSelection);
    }

    render() {
        const fields: Field[] = this.context.filterableUIFields || [];        

        const facetsToDisplay = fields.filter((f) => 
            f.userSettings.showInFacetArea && f.systemSettings.isFacetable && f.name !== DefaultFieldNames.TimeStart && f.name !== DefaultFieldNames.Duration);

        let selectedFacetValues = this.context.facetSelections;

        return (
            <div className="analytics-div">
                {
                    facetsToDisplay.map(facet => {
                        const facetValues = this.context.facetsValues.find((fv) => fv.facetName === facet.name);
                        if (!facetValues) {
                            log.warn(`[AnalyticsResult] No facet values found for field: ${facet.name}`);
                            return null;
                        }
                        

                        return (
                            <PieChartFacetField
                                key={facet.name}
                                selectedFacetValues={selectedFacetValues}
                                fieldName={facet.name}
                                name={facet.systemSettings.displayName}
                                onChangeFacetPie={this.facetChanged}                                
                                allFacetValues={facetValues}
                            />
                        );
                    })
                }
            </div>
        );
    }
}

export default AnalyticsResult;

interface PieChartFacetFieldProps {
    selectedFacetValues: FacetValues<FacetValue>[];
    fieldName: string;
    name: string;
    onChangeFacetPie:  (facetName: string, facetValue: FacetValue) => void;
    allFacetValues: FacetValuesCount;
}

const PieChartFacetField: React.FC<PieChartFacetFieldProps> = ({ selectedFacetValues, fieldName, name, onChangeFacetPie, allFacetValues }) => {
    return (
        <FacetFieldPieCharts selectedFacetValues={selectedFacetValues} onChangeFacetPie={onChangeFacetPie} fieldName={fieldName} name={name} allFacetValues={allFacetValues} />
    );
}
